import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ModuleService } from '../services/module.service';
import { ClubModule } from '@modules/application/application';

@Injectable({
    providedIn: 'root',
})
export class ModulesResolve implements Resolve<ClubModule[]> {
    constructor(private moduleService: ModuleService) {}

    resolve(): Observable<ClubModule[]> {
        return this.moduleService.getModules().pipe(
            catchError(() => {
                return of([]);
            })
        );
    }
}
